var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box", class: "box_" + _vm.type }, [
    _c("div", { staticClass: "badge", class: "badge_" + _vm.type }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.lang.related["estate_" + _vm.type + "_title"]) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("a", { attrs: { href: _vm.related_estate.detail_url } }, [
        _vm._v(_vm._s(_vm.related_estate.title))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "related_estate_price" }, [
      _c("a", { attrs: { href: _vm.related_estate.detail_url } }, [
        _c("div", {
          staticClass: "price",
          domProps: { innerHTML: _vm._s(_vm.related_estate.price) }
        })
      ]),
      _vm._v(" "),
      _vm.related_estate.estate_other_contract
        ? _c("div", { staticClass: "other_contract" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.related_estate.estate_other_contract.detail_url
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.lang.labels.also) +
                    " " +
                    _vm._s(
                      _vm.$root.lang.words.contract[
                        _vm.related_estate.estate_other_contract.contract
                      ]
                    ) +
                    " \n                "
                ),
                _c(
                  "div",
                  { staticClass: "detail_price" },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.related_estate.estate_other_contract.price
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("masked-image", {
                      staticClass: "costs-details",
                      attrs: {
                        src: "/img/icons/linear-arrow-right.svg",
                        width: "13",
                        height: "13"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "estate-card-data" }, [
      _vm.related_estate.rooms
        ? _c(
            "div",
            [
              _c("masked-image", { attrs: { src: "/img/icons/rooms.svg" } }),
              _vm._v(" " + _vm._s(_vm.related_estate.rooms) + "\n        ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.related_estate.surface
        ? _c(
            "div",
            [
              _c("masked-image", { attrs: { src: "/img/icons/surface.svg" } }),
              _vm._v("  " + _vm._s(_vm.related_estate.surface) + "\n        ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.related_estate.bathrooms
        ? _c(
            "div",
            [
              _c("masked-image", {
                attrs: { src: "/img/icons/bathrooms.svg" }
              }),
              _vm._v(" " + _vm._s(_vm.related_estate.bathrooms) + "\n        ")
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }